import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from './@core/authentication/auth.guard';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';

export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'external',
    loadChildren: () =>
      import('./external/external-pages.module').then(
        (m) => m.ExternalPagesModule,
      ),
  },
  {
    path: 'e',
    loadChildren: () =>
      import('./external/external-pages.module').then(
        (m) => m.ExternalPagesModule,
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./@core/authentication/auth.module').then((m) => m.AuthModule),
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: 'pages' },
];

// Check if running in iframe (for MSAL redirect handling)
const isIframe = window !== window.parent && !window.opener;

const config: ExtraOptions = {
  useHash: false,
  // Don't perform initial navigation in iframes or popups
  initialNavigation:
    !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
      ? 'enabledNonBlocking'
      : 'disabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
